<scf-common-form
  [title]="'agentStatistics.title'"
  [subtitle]="'tariffs.subtitle'"
  (consultEvent)="loadDataTable($event)"
  [isDetailAvailable]="true"
>
</scf-common-form>

<div *ngIf="data">
  <div *ngIf="data?.items.length > 0; else showNoOperations">
    <scf-agent-statistic-table *ngFor="let item of data.items" [data]="item"></scf-agent-statistic-table>

    <mat-card>
      <mat-card-header>
        <h2>{{ 'agentStatistics.totalAgent' | translate | uppercase }}</h2>
      </mat-card-header>
      <mat-card-content>
        <div class="table__wrapper">
          <table aria-label="totals" mat-table [dataSource]="totals">
            <ng-container matColumnDef="numOperation">
              <th mat-header-cell *matHeaderCellDef class="first-row" translate>agentStatistics.numOperation</th>
              <td mat-cell *matCellDef="let element" class="first-row">{{ data.totalNumOperations }}</td>
            </ng-container>
            <ng-container matColumnDef="investment">
              <th mat-header-cell *matHeaderCellDef translate>agentStatistics.investment</th>
              <td mat-cell *matCellDef="let element">{{ data.totalInversion | transformNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="TIR">
              <th mat-header-cell *matHeaderCellDef translate>agentStatistics.TIR</th>
              <td mat-cell *matCellDef="let element">{{ data.totalTirAverage | transformNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="PI">
              <th mat-header-cell *matHeaderCellDef translate>agentStatistics.PI</th>
              <td mat-cell *matCellDef="let element">{{ data.totalTermsAverage | transformNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="totalCommissionAgent">
              <th mat-header-cell *matHeaderCellDef translate>agentStatistics.totalCommissionAgent</th>
              <td mat-cell *matCellDef="let element">{{ data.totalAgentCommission | transformNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="percentageCommission">
              <th mat-header-cell *matHeaderCellDef translate>agentStatistics.percentageCommission</th>
              <td mat-cell *matCellDef="let element">{{ this.data.totalPercentCommission | transformNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="totalCommission">
              <th mat-header-cell *matHeaderCellDef translate>agentStatistics.totalCommission</th>
              <td mat-cell *matCellDef="let element">{{ this.data.totalCommissions | transformNumber }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <ng-template #showNoOperations>
    <mat-card>
      <mat-card-content>
        <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
          <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-template>
</div>

<div class="panel_footer__buttons" *ngIf="data?.items.length > 0">
  <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
    <button
      id="createAllExcelPanel"
      mat-stroked-button
      color="accent"
      (click)="createExcel()"
      [disabled]="data?.items.length <= 0"
    >
      <mat-icon class="icon-ic_file_download"></mat-icon>
      <span>{{ 'request.button.excel' | translate | uppercase }}</span>
    </button>
    <button
      id="createAllPdfPanel"
      mat-stroked-button
      color="accent"
      (click)="createPdf()"
      [disabled]="data?.items.length <= 0"
    >
      <mat-icon class="icon-ic_print"></mat-icon>
      <span>{{ 'request.button.print' | translate | uppercase }}</span>
    </button>
  </div>
</div>
